import colors from "assets/theme/base/colors";

function categoryColor(category) {
  let background;
  const { gradients } = colors;

  if (category === "water") {
    background = gradients.blue;
  } else if (category === "agriculture") {
    background = gradients.yellow;
  } else if (category === "ecology") {
    background = gradients.green;
  }
  return background;
}
export default categoryColor;
